import { useEffect, useState } from "react";
import { Modal, Spin, Input, Checkbox } from "antd";
import { Link } from "react-router-dom";
import dataJson from "@/../public/data.json";
import { cloneDeep } from "lodash-es";
import { publicPath } from "@/utils/base";
import "./bindModal.less";

const prefix = "bindModal";

interface Props {
  addOpen: boolean;
  devicePluginLoading: boolean;
  value?: any[];
  data: any[];
  handleSeach: (e: any) => void;
  handleAddOpenOk: (e: any) => void;
  handleAddCancel: () => void;
}
const { app_list, two_bars, create, product_detail } = dataJson;
const { package_version } = product_detail.device_plugin;

function BindModal(props: Props) {
  const { addOpen, devicePluginLoading, value, data, handleSeach, handleAddOpenOk, handleAddCancel } = props;
  const [addOpenLoading, setAddFormLoading] = useState(false);
  const [list, setList] = useState<any[]>(data);

  const getImg = (item: any) => {
    if (item?.resources[0]?.url) {
      return item?.resources[0]?.url;
    } else {
      return app_list.init_img;
    }
  };

  const onChange = (e: any, item: any) => {
    const listCopy = cloneDeep(list);
    const listMap = listCopy.map((ele: any) => {
      const eleCopy = cloneDeep(ele);
      eleCopy.id === item.id && (eleCopy.checked = e.target.checked);
      return eleCopy;
    });
    setList(listMap);
  };

  const onOk = () => {
    setAddFormLoading(true);
    const checkArr = list.filter((item: any) => {
      return item.checked;
    });
    handleAddOpenOk(checkArr);
  };

  const onCancel = () => {
    const listCopy = cloneDeep(list);
    listCopy.forEach((item: any) => {
      item.checked = false;
    });
    setList(listCopy);
    handleAddCancel();
  };

  useEffect(() => {
    setList(data);
  }, [data]);

  useEffect(() => {
    !addOpen && setAddFormLoading(false);
  }, [addOpen]);

  return (
    <Modal
      title={product_detail.device_plugin.binding + product_detail.device_plugin.device_plugin_text}
      // centered
      destroyOnClose
      confirmLoading={addOpenLoading}
      open={addOpen}
      onOk={onOk}
      onCancel={onCancel}
      width={1000}
    >
      <Spin spinning={devicePluginLoading}>
        <div className={prefix}>
          <div className={`${prefix}-header`}>
            <Input
              placeholder={product_detail.device_plugin.filter_form.name_placeholder}
              onPressEnter={handleSeach}
              style={{ width: 296 }}
            ></Input>
            <Link to={`${publicPath}/my_device_plugin`}>{create + product_detail.device_plugin.device_plugin_text}</Link>
          </div>
          <div className={`${prefix}-content`}>
            {list.map((item: any) => {
              return (
                <div key={item.id} className={`${prefix}-content-item`}>
                  <div
                    className={`${prefix}-content-status`}
                    style={{ color: item?.textColor, backgroundColor: item?.bgColor }}
                  >
                    <Checkbox
                      checked={item.checked}
                      onChange={(e) => {
                        onChange(e, item);
                      }}
                      disabled={item?.hasBindProduct}
                    ></Checkbox>
                  </div>
                  <div className={`${prefix}-content-inner`}>
                    <img src={getImg(item)} alt="" />
                    <div className={`${prefix}-content-box one-line-ellipsis`}>
                      <div title={item?.name} className={`${prefix}-content-title one-line-ellipsis`}>
                        {item?.name || two_bars}
                      </div>
                      <div className="one-line-ellipsis">
                        {package_version}
                        {item.version}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </Spin>
    </Modal>
  );
}

export default BindModal;
